type JsonTemplateValidationError =
  | "invalid_json"
  | "invalid_root"
  | "missing_placeholder_value"
  | "multiple_placeholders"

interface JsonTemplateValidationOptions {
  allowBarePlaceholder?: boolean
  requireObject?: boolean
}

function containsPlaceholderValue(
  value: unknown,
  placeholder: string,
): boolean {
  if (typeof value === "string") {
    return value.includes(placeholder)
  }

  if (Array.isArray(value)) {
    return value.some((item) => containsPlaceholderValue(item, placeholder))
  }

  if (typeof value === "object" && value !== null) {
    return Object.values(value).some((item) =>
      containsPlaceholderValue(item, placeholder),
    )
  }

  return false
}

export function validateJsonTemplatePlaceholder(
  template: string,
  placeholder: string,
  options: JsonTemplateValidationOptions = {},
): JsonTemplateValidationError | null {
  const placeholderCount = template.split(placeholder).length - 1
  if (placeholderCount === 0) {
    return "missing_placeholder_value"
  }
  if (placeholderCount > 1) {
    return "multiple_placeholders"
  }

  if (options.allowBarePlaceholder && template === placeholder) {
    return null
  }

  let parsed: unknown
  try {
    parsed = JSON.parse(template)
  } catch {
    return "invalid_json"
  }

  if (
    options.requireObject &&
    (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
  ) {
    return "invalid_root"
  }

  return containsPlaceholderValue(parsed, placeholder)
    ? null
    : "missing_placeholder_value"
}
